import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';

const XPGainNotification = ({ xpGained, onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onComplete();
      }, 300);
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-24 right-6 z-50 animate-scale-in">
      <div className="bg-success/20 border-2 border-success/50 rounded-lg p-4 shadow-elevation-3 backdrop-blur-sm">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-success/30 rounded-full flex items-center justify-center animate-pulse">
            <Icon name="Zap" size={24} color="var(--color-success)" strokeWidth={2.5} />
          </div>
          <div>
            <p className="text-sm font-medium text-success-foreground">XP Gained!</p>
            <p className="text-2xl font-bold text-success">+{xpGained} XP</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default XPGainNotification;